import { render, staticRenderFns } from "./RendicionPagination.vue?vue&type=template&id=2904c1b8&"
import script from "./RendicionPagination.vue?vue&type=script&lang=js&"
export * from "./RendicionPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports